import "../scss/main.scss";
import 'owl.carousel';
import "hamburgers";

var fGrid = require('./grid.js');
var fAccordion = require('./accordion.js');
var fNextSection = require('./next-section.js');
var fjsclock = require('./jsclock.js');
var fHeader = require('./header.js');
var fBanner = require('./banner.js');
var fBannerSlider = require('./banner-slider.js');

import Vue from "vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import blog from "./blog.vue"; 
import cgi from "./cgi.vue"; 
import film from "./film.vue"; 

Vue.use(VueAxios, axios);

function fBlog() {
    if(document.getElementById("blog")) {
        new Vue({
            el: "#blog", 
            name: "Blog",
            render: h => h(blog),
        })
    }
}

function fCGI() {
    if(document.getElementById("cgi")) {
        new Vue({
            el: "#cgi", 
            name: "CGI",
            render: h => h(cgi)
        })
    }
}

function fFilm() {
    if(document.getElementById("film")) {
        new Vue({
            el: "#film", 
            name: "Film",
            render: h => h(film),
        })
    }
}

function refreshScripts() {
    fCGI();
    fGrid();
    fAccordion();
    fNextSection();
    fjsclock();
    fBlog();
    fHeader();
    fBanner();
    fBannerSlider();
    fFilm();
}

$(document).ready(function() {
    refreshScripts();
    
    $('body').fadeIn(800);
    
    // if(window.location.href.includes('places')) {
    //     $('#menu-top-menu .menu-item > a[href="'+window.location.origin+'/places/"]').parent().addClass('current-menu-item');
    // }
    
    /*
    $(document).on('click', 'a:not([target="_blank"])', function(e) {
        
        e.preventDefault();
        let _this = $(this);
        let url = _this.attr('href');
        let newUrl = url.replace(/^.*\/\/[^\/]+/, '');
        
        newUrl = (!newUrl) ? url : newUrl;

        if(window.location.href.replace(/\/$/, "") != url.replace(/\/$/, "")) {
            $('#main').fadeOut(300);
            $('.footer').fadeOut(200);
            
            $.ajax({
                url: url,
                type: "POST",
                datattype: "html",
                success: function(data) {
                    
                    var result = $.parseHTML(data);
                        
                    let html = result.find(x => x.id == 'main');
                    let title = result.find(x => x.nodeName == 'TITLE');
                    $(window).scrollTop(0);
                    $('#main').html(html);
                    $(document).ready();
                    
                    history.pushState({}, null, newUrl);
                    document.title = title.innerHTML

                    refreshScripts();
                    
                    $('#menu-top-menu .menu-item').removeClass('current-menu-item');
                    let currMenu = $('#menu-top-menu .menu-item > a[href$="'+url+'"]');
                    $(currMenu).parent().addClass('current-menu-item');
                    
                    if(url.includes('places')) {
                        $('#menu-top-menu .menu-item > a[href="'+window.location.origin+'/places/"]').parent().addClass('current-menu-item');
                    }
                    
                    $('#main').fadeIn(800);
                    $('.footer').delay(300).fadeIn(800);
                },
            });
        }
    });
    
    window.onpopstate = function(e) {
        $('#main').fadeOut(300);
        $('.footer').fadeOut(300);

        $('#menu-top-menu .menu-item').removeClass('current-menu-item');
        let currMenu = $('#menu-top-menu .menu-item > a[href$="'+e.target.location.href+'"]');
        $(currMenu).parent().addClass('current-menu-item');
        
        if(e.target.location.href.includes('places')) {
            $('#menu-top-menu .menu-item > a[href="'+window.location.origin+'/places/"]').parent().addClass('current-menu-item');
        }
            
        $.ajax({
            url: e.target.location.href,
            type: "POST",
            datattype: "html",
            success: function(data) {
                var result = $.parseHTML(data);
                let html = result.find(x => x.id == 'main')    
                let title = result.find(x => x.nodeName == 'TITLE');
                document.title = title.innerHTML
                $(window).scrollTop(0);
                $('#main').html(html);
                $(document).ready();

                refreshScripts();
                
                
                
                $('#main').fadeIn(800);
                $('.footer').fadeIn(800);
            },
        });
    }*/
});

